// pass  276403

const constantApi = {
 // baseUrl: "https://api.jtserp.cloud/api",
  //imageUrl: "https://api.jtserp.cloud/uploads",
  //addUrl: "https://api.jtserp.cloud",

   baseUrl: "https://api.islamicbookzone.com/api",
   imageUrl: "https://api.islamicbookzone.com/uploads",
  
 addUrl: "https://api.islamicbookzone.com",

  // baseUrl: "http://localhost:5610/api",
  // imageUrl: "http://localhost:5610/uploads",
  // addUrl: "http://localhost:5610",

  // Any other services (if needed)
  tripUrl: "http://localhost:5173/services", // keep local if still used during development
};
export default constantApi;
